module.exports = __webpack_public_path__ + "img/8007.9c9decd3.gif";